import {
  Button,
  Card,
  Grid,
  InputItem,
  List,
  Modal,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
import { ProductionTaskBoardItemDTO } from "../schema";
import React, { useCallback, useEffect, useState } from "react";
import instance from "../../../util/axios";
import { Result } from "../../../schema";
import dayjs from "dayjs";
import DictionarySelect from "../../../component/CheckBoxItem";

export default function Board(): JSX.Element {
  const [data, setData] = useState<ProductionTaskBoardItemDTO[]>([]);
  const [submitForm, setSubmitForm] = useState<{
    visible: boolean;
    password?: string;
    count?: number;
    totalCount?: number;
    status?: string;
    date?: string;
    radId?: string;
    userId?: string;
    workshopId?: string;
    procedureId?: string;
    produceOrderId?: string;
    produceOrderDetailId?: string;
    bomDetailId?: string;
  }>({
    visible: false,
  });
  const [revertForm, setRevertForm] = useState<{
    visible: boolean;
    password?: string;
    count?: number;
    totalCount?: number;
    status?: string;
    date?: string;
    radId?: string;
    userId?: string;
    workshopId?: string;
    procedureId?: string;
    produceOrderId?: string;
    produceOrderDetailId?: string;
    bomDetailId?: string;
  }>({
    visible: false,
  });
  const [reportForm, setReportForm] = useState<{
    visible: boolean;
    password?: string;
    count?: number;
    status?: string;
    date?: string;
    radId?: string;
    userId?: string;
    workshopId?: string;
    procedureId?: string;
    produceOrderId?: string;
    produceOrderDetailId?: string;
    bomDetailId?: string;
    type?: string;
    remark?: string;
  }>({
    visible: false,
    remark: "",
  });

  const load = useCallback(() => {
    instance
      .get<Result<ProductionTaskBoardItemDTO[]>>(
        `/erp/production-tasks/board-mobile`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setData(resp.data.Data);
        } else {
          Toast.fail(resp.data.Message);
        }
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      {data.map((item) => (
        <WingBlank size="lg">
          <WhiteSpace size="lg" />
          <Card>
            <Card.Header
              title={item.produceOrderSerialNumber}
              extra={<span>{dayjs(item.date).format("YYYY-MM-DD")}</span>}
            />
            <Card.Body>
              <Grid
                square={false}
                hasLine={false}
                data={[
                  {
                    text: item.formulaName,
                  },
                  {
                    text: item.model,
                  },
                  {
                    text: item.procedureName,
                  },
                  {
                    text: "数量：" + item.count,
                  },
                  {
                    text: "剩余：" + (item.count - item.completeCount),
                  },
                  {
                    text: item.bomDetailId ? "物料：" + item.skuName : "",
                  },
                ]}
                columnNum={2}
              />
            </Card.Body>
            <Card.Footer
              content={
                <>
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td>
                        <Button
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSubmitForm({
                              visible: true,
                              totalCount: item.count - item.completeCount,
                              status: "2",
                              date: dayjs(item.date).format("YYYY-MM-DD"),
                              radId: item.radId,
                              userId: item.userId,
                              workshopId: item.workshopId,
                              procedureId: item.procedureId,
                              produceOrderId: item.produceOrderId,
                              produceOrderDetailId: item.produceOrderDetailId,
                              bomDetailId: item.bomDetailId || "",
                            });
                          }}
                        >
                          完成
                        </Button>
                      </td>
                      {item.unConfirmCount > 0 && (
                        <td>
                          <Button
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setRevertForm({
                                visible: true,
                                status: "3",
                                totalCount: item.unConfirmCount,
                                date: dayjs(item.date).format("YYYY-MM-DD"),
                                radId: item.radId,
                                userId: item.userId,
                                workshopId: item.workshopId,
                                procedureId: item.procedureId,
                                produceOrderId: item.produceOrderId,
                                produceOrderDetailId: item.produceOrderDetailId,
                                bomDetailId: item.bomDetailId || "",
                              });
                            }}
                          >
                            撤销
                          </Button>
                        </td>
                      )}
                      {item.reportCount > 0 && (
                        <td>
                          <Button
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setReportForm({
                                visible: true,
                                status: "2",
                                date: dayjs(item.date).format("YYYY-MM-DD"),
                                radId: item.radId,
                                userId: item.userId,
                                workshopId: item.workshopId,
                                procedureId: item.procedureId,
                                produceOrderId: item.produceOrderId,
                                produceOrderDetailId: item.produceOrderDetailId,
                                bomDetailId: item.bomDetailId || "",
                              });
                            }}
                          >
                            异常
                          </Button>
                        </td>
                      )}
                    </tr>
                  </table>
                </>
              }
            />
          </Card>
          <WhiteSpace size="lg" />
        </WingBlank>
      ))}
      <Modal
        title={"提交"}
        visible={submitForm.visible}
        onClose={() =>
          setSubmitForm({
            visible: false,
          })
        }
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "确定",
            onPress: async () => {
              if (
                !submitForm.count ||
                !submitForm.totalCount ||
                submitForm.count > submitForm.totalCount
              ) {
                Toast.fail(`提交数量有误`);
                return;
              }
              Toast.loading("处理中...");
              const taskIdsResp = await instance.post<Result<string>>(
                `/erp/production-tasks/boardTaskIds`,
                {
                  status: submitForm.status,
                  date: submitForm.date,
                  radId: submitForm.radId,
                  userId: submitForm.userId,
                  workshopId: submitForm.workshopId,
                  procedureId: submitForm.procedureId,
                  produceOrderId: submitForm.produceOrderId,
                  produceOrderDetailId: submitForm.produceOrderDetailId,
                  bomDetailId: submitForm.bomDetailId,
                }
              );
              if (taskIdsResp.data.Status === "1" && taskIdsResp.data.Data) {
                const taskIds = taskIdsResp.data.Data.split(",");
                let submitCount = 0;
                let errorMessage: string | null = null;
                for (const taskId of taskIds) {
                  const resp = await instance.post<Result<string>>(
                    `/erp/production-tasks/${taskId}/submit`,
                    {
                      password: "",
                    }
                  );
                  if (resp.data.Status === "1") {
                    submitCount++;
                  } else {
                    errorMessage = resp.data.Data;
                    break;
                  }
                  if (submitCount === submitForm.count) {
                    Toast.hide();
                    Toast.success("提交成功！");
                    break;
                  }
                }
                if (submitCount < submitForm.count) {
                  Toast.hide();
                  Toast.fail(
                    `遇到问题，原因：${errorMessage}！本次成功提交数量：${submitCount}`
                  );
                }
                setSubmitForm({
                  visible: false,
                });
                load();
              } else {
                Toast.hide();
                Toast.fail(taskIdsResp.data.Message);
                setSubmitForm({
                  visible: false,
                });
                load();
              }
            },
          },
        ]}
      >
        <List>
          <InputItem
            min={0}
            type={"digit"}
            value={submitForm.count + ""}
            onChange={(value) => {
              const count = parseInt(value);
              setSubmitForm((prevState) => ({
                ...prevState,
                count: count,
              }));
            }}
          >
            提交数量:
          </InputItem>
        </List>
      </Modal>
      <Modal
        title={"撤销"}
        visible={revertForm.visible}
        onClose={() =>
          setRevertForm({
            visible: false,
          })
        }
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "确定",
            onPress: async () => {
              if (
                !revertForm.count ||
                !revertForm.totalCount ||
                revertForm.count > revertForm.totalCount
              ) {
                Toast.fail(`撤销数量有误`);
                return;
              }
              Toast.loading("处理中...");
              const taskIdsResp = await instance.post<Result<string>>(
                `/erp/production-tasks/boardTaskIds`,
                {
                  status: revertForm.status,
                  date: revertForm.date,
                  radId: revertForm.radId,
                  userId: revertForm.userId,
                  workshopId: revertForm.workshopId,
                  procedureId: revertForm.procedureId,
                  produceOrderId: revertForm.produceOrderId,
                  produceOrderDetailId: revertForm.produceOrderDetailId,
                  bomDetailId: reportForm.bomDetailId,
                }
              );
              if (taskIdsResp.data.Status === "1" && taskIdsResp.data.Data) {
                const taskIds = taskIdsResp.data.Data.split(",");
                let revertCount = 0;
                let errorMessage: string | null = null;
                for (const taskId of taskIds) {
                  const resp = await instance.post<Result<string>>(
                    `/erp/production-tasks/${taskId}/revert`,
                    {
                      password: "",
                    }
                  );
                  if (resp.data.Status === "1") {
                    revertCount++;
                  } else {
                    errorMessage = resp.data.Data;
                    break;
                  }
                  if (revertCount === revertForm.count) {
                    Toast.hide();
                    Toast.success("撤销成功！");
                    break;
                  }
                }
                if (revertCount < revertForm.count) {
                  Toast.hide();
                  Toast.fail(
                    `遇到问题，原因：${errorMessage}！本次成功撤销数量：${revertCount}`
                  );
                }
                setRevertForm({
                  visible: false,
                });
                load();
              } else {
                Toast.hide();
                Toast.fail(taskIdsResp.data.Message);
                setRevertForm({
                  visible: false,
                });
                load();
              }
            },
          },
        ]}
      >
        <List>
          <InputItem
            min={0}
            type={"digit"}
            value={revertForm.count + ""}
            onChange={(value) => {
              const count = parseInt(value);
              setRevertForm((prevState) => ({
                ...prevState,
                count: count,
              }));
            }}
          >
            撤销数量:
          </InputItem>
        </List>
      </Modal>
      <Modal
        title={"报告异常"}
        visible={reportForm.visible}
        onClose={() =>
          setReportForm({
            visible: false,
          })
        }
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "确定",
            onPress: async () => {
              if (!reportForm.count) {
                Toast.fail(`异常数量有误`);
                return;
              }
              if (!reportForm.type) {
                Toast.fail(`请选择异常类型`);
                return;
              }
              Toast.loading("处理中...");
              const taskIdsResp = await instance.post<Result<string>>(
                `/erp/production-tasks/boardTaskIds`,
                {
                  status: reportForm.status,
                  date: reportForm.date,
                  radId: reportForm.radId,
                  userId: reportForm.userId,
                  workshopId: reportForm.workshopId,
                  procedureId: reportForm.procedureId,
                  produceOrderId: reportForm.produceOrderId,
                  produceOrderDetailId: reportForm.produceOrderDetailId,
                  bomDetailId: reportForm.bomDetailId,
                  type: "report",
                }
              );
              if (taskIdsResp.data.Status === "1" && taskIdsResp.data.Data) {
                const taskIds = taskIdsResp.data.Data.split(",");
                if (reportForm.count > taskIds.length) {
                  Toast.hide();
                  Toast.fail("异常数量有误");
                  return;
                }
                let reportCount = 0;
                let errorMessage: string | null = null;
                for (const taskId of taskIds) {
                  const resp = await instance.post<Result<string>>(
                    `/erp/production-tasks/${taskId}/report`,
                    {
                      password: "",
                      type: reportForm.type,
                    }
                  );
                  if (resp.data.Status === "1") {
                    reportCount++;
                  } else {
                    errorMessage = resp.data.Data;
                    break;
                  }
                  if (reportCount === reportForm.count) {
                    Toast.hide();
                    Toast.success("报告异常成功！");
                    break;
                  }
                }
                if (reportCount < reportForm.count) {
                  Toast.hide();
                  Toast.fail(
                    `遇到问题，原因：${errorMessage}！本次成功报告异常数量：${reportCount}`
                  );
                }
                setReportForm({
                  visible: false,
                });
                load();
              } else {
                Toast.hide();
                Toast.fail(taskIdsResp.data.Message);
                setReportForm({
                  visible: false,
                });
                load();
              }
            },
          },
        ]}
      >
        <List>
          <InputItem
            min={0}
            type={"digit"}
            value={reportForm.count + ""}
            onChange={(value) => {
              const count = parseInt(value);
              setReportForm((prevState) => ({
                ...prevState,
                count: count,
              }));
            }}
          >
            撤销数量:
          </InputItem>
        </List>
        <List>
          <DictionarySelect
            title={"异常类型:"}
            multiple={false}
            dictionary={"erp_extra_task_type"}
            value={reportForm.type}
            onChange={(value) => {
              setReportForm((prevState) => ({
                ...prevState,
                type: value,
              }));
            }}
          />
        </List>
      </Modal>
    </>
  );
}
